angular.module('tradersyard').controller('User.Settings.Account.Ctrl', [
    '$scope',
    'graph-analytic-factory',
    '$flex',
    '$timeout',
    function ($scope, $factory, $flex, $timeout) {
        $scope.node = {};
        $scope.params = {
            page: 0,
        };
        $scope.accounts = [];
        $scope.space = 'me';

        angular.extend($scope, $flex.data);

        $scope.$on('touch:accounts', function () {
            $scope.query();
        });

        $scope.visible = function (account) {
            if (account.visible === true) {
                $factory.visible($scope.space, account.id).then(function (response) {
                    if (response.data.state === 0) {
                        account.visible = true;
                    }
                });
            } else {
                $factory.invisible($scope.space, account.id).then(function (response) {
                    if (response.data.state === 0) {
                        account.visible = false;
                    }
                });
            }
        };

        $scope.filtrate = function (value) {
            return value && value.length > 0 && value.length <= 255;
        };

        $scope.update = function (account) {
            $timeout(function () {
                $factory
                    .update($scope.space, account.id, { display_name: account.display_name })
                    .then(function (response) {
                        if (response.data.state === 0) {
                            //
                        }
                    });
            }, 10);
        };

        $scope.query = function (next) {
            ++$scope.params.page;
            $factory.accounts($scope.space, { params: $scope.params }).then(function ($response) {
                if ($response.data.state === 0 && $response.data.data.length > 0) {
                    $scope.accounts = $scope.accounts.concat($response.data.data);

                    if (next) next();
                }
            });
        };

        $scope.main = function ($account) {
            $factory.main($scope.space, $account.id).then(function ($response) {
                if ($response.data.state === 0) {
                    $scope.accounts.forEach(function (account) {
                        if (account.main === true) account.main = false;
                    });

                    $account.main = true;
                }
            });
        };
    },
]);
